<template>
	<div class="link-list-item horizontal-center" @click="onClick">
		<img v-if="icon" class="icon" :src="iconPath" />
		<div class="list-title">{{ title }}</div>
		<div class="space"></div>
		<img class="arrow" :src="require('@/assets/icons/link_list_item/arrow.svg')" />
	</div>
</template>

<script>

export default {
	name: 'LinkListItem',
	props: {
		title: {
			type: String,
			default: '',
		},
		icon: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	computed: {
		iconPath: function() {
			return require('@/assets/icons/link_list_item/' + this.icon + '.svg');
		},
	},
	methods: {
		onClick: function() {
			this.$emit('click');
		},
	},
}
</script>

<style lang="scss">

</style>
